<template>
    <div
        class="lg:shadow-base lg:rounded-block w-full lg:z-10 lg:bg-white lg:px-6 lg:py-8"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BaseDesktopBlockContainer'
};
</script>
